<template >
  <div class="raboti">
    <div class="raboti__one">
      <div class="raboti__one-card">
        <img :src="rImg" alt="" class="raboti__one-card__i">
        <div class="raboti__one-card__menu" :class="{maxHeight:menuH, minHeight:!menuH}">
          <img @click="menuH = !menuH" class="raboti__one-card__menu-icon" :class="{hIcon:menuH}" src="../../assets/img/arrow-top.svg" alt="">
          <div class="raboti__one-card__menu-imgCard">
            <img v-for="one in rOne" @click="rImgClick(one.img)" :src="one.img" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="raboti__two">
      <div class="raboti__two-orinter">
        <h2>Feliallar</h2>
        <ul class="raboti__two-orinter__list">
          <li v-for="two in rTwo" @click="locationCity(two.bool)">{{two.city}}</li>
        </ul>
      </div>
      <div class="raboti__two-location">
        <iframe v-if="cityBool == 'chilanzar'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.516028603461!2d69.20139976371253!3d41.275872440824415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8a22d8b4347d%3A0x18b72c3133debcf4!2z0LzQtdGC0YDQviDQp9C40LvQsNC90LfQsNGA!5e0!3m2!1sru!2s!4v1673972211612!5m2!1sru!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <iframe v-if="cityBool == 'olmazor'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2999.398981801452!2d69.19347531572414!3d41.25664801205208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8a017d09c86b%3A0xb38fa4ce8b2145b2!2z0J7Qu9C80LDQt9C-0YA!5e0!3m2!1sru!2s!4v1673972293399!5m2!1sru!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <iframe v-if="cityBool == 'sergili'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.5230694678794!2d69.21077273261346!3d41.232162747298275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae61947afb5fb3%3A0x4eb5241eda3b95f1!2sSergeli%20Moshina%20Bozor!5e0!3m2!1sru!2s!4v1673972771639!5m2!1sru!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <iframe v-if="cityBool == 'yunusabod'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5988.736851324595!2d69.26985558751423!3d41.36607955386045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8cc9b2decb6f%3A0x69e6501a61f0bee2!2z0K7QvdGD0YHQsNCx0LDQtC00LCDQotCw0YjQutC10L3RgiAxMDAwOTMsINCj0LfQsdC10LrQuNGB0YLQsNC9!5e0!3m2!1sru!2s!4v1673972826361!5m2!1sru!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import "swiper/css/free-mode"
import "swiper/css/navigation"
import "swiper/css/thumbs"


// import required modules
import {FreeMode,Navigation,Thumbs} from 'swiper';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      menuH:false,
      cityBool: 'chilanzar',
      rImg: require('@/assets/img/raboti__one-img.png')
    }
  },
  props:{
    rOne:Array,
    rTwo:Array,
  },
  setup() {
    let thumbsSwiper = null;
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper = swiper;
    }
    return {
      modules: [FreeMode,Navigation,Thumbs],
    };
  },
  methods:{
    locationCity(city){
      this.cityBool = city
    },
    rImgClick(img){
      this.rImg = img
    }
  }
}
</script>
<style lang="">
  
</style>